import logo from "../../assets/images/logo.png";
import hamburgerIcon from "../../assets/icons/hamburger.png";
import NavModal from "../navModal/NavModal";
import { useState } from "react";
import "./Navbar.scss";

function Navbar() {
  const [hamburger, setHamburger] = useState(true);

  const hamburgerHandler = () => {
    setHamburger((prev) => !prev);
  };

  const isMenuOpen = hamburger === false;

  return (
    <header className="navbar">
      <a
        className="navbar__logo--a-tag"
        href="/"
        aria-label="Chanho Kim homepage"
        data-section="logo"
      >
        <img className="navbar__logo" src={logo} alt="Chanho Kim, Full Stack Developer | Analytics-focused" width={630} />
      </a>

      <button
        type="button"
        className={isMenuOpen ? "navbar__btn--open" : "navbar__btn"}
        onClick={hamburgerHandler}
        aria-label={
          isMenuOpen ? "Close navigation menu" : "Open navigation menu"
        }
        aria-expanded={isMenuOpen}
        aria-controls="mobile-navigation"
      >
        <img
          className="navbar__btn-icon"
          src={hamburgerIcon}
          alt=""
          aria-hidden="true"
          width={456}
        />
      </button>

      {isMenuOpen && <NavModal setHamburger={setHamburger} />}

      <nav
        className="navbar__menu-box"
        id="primary-navigation"
        aria-label="Primary navigation"
      >
        <ul className="navbar__list">
          <li className="navbar__item">
            <a className="navbar__menu" href="/#home" data-section="home">
              Home
            </a>
          </li>
          <li className="navbar__item">
            <a
              className="navbar__menu"
              href="/#projects"
              data-section="projects"
            >
              Projects
            </a>
          </li>
          <li className="navbar__item">
            <a className="navbar__menu" href="/#skills" data-section="skills">
              Skills
            </a>
          </li>
          <li className="navbar__item">
            <a className="navbar__menu" href="/#about" data-section="about">
              About Me
            </a>
          </li>
          <li className="navbar__item">
            <a className="navbar__menu" href="/#contact" data-section="contact">
              Contact
            </a>
          </li>
        </ul>
      </nav>
    </header>
  );
}

export default Navbar;